
import Vue from 'vue'
import Transformer from '@/transformers/transformer'
import moment from 'moment'

class SinisterTransformer extends Transformer {
	static fetch({sinister_id, sinister_road_id, requisition_number,
							  date_assignment, sinister_number}) {
		return {
			id: sinister_road_id,
			sinisterId: sinister_id,
			sinisterNumber: sinister_number,
			requisitionNumber: requisition_number,
			dateAssignment: date_assignment,
		}
	}
}

const filtersTransformer = ( { fromDate, toDate, highway, revi} ) => {
  return {
    fromDate: !!fromDate ? moment(fromDate).format('YYYY-MM-DD') : undefined,
    toDate: !!toDate ? moment(toDate).format('YYYY-MM-DD') : undefined,
    highway: highway || undefined,
	revi: revi || undefined,
  }
}


export default (statusId, params={}) => {
	return Vue.$http.get(`/sinisters/macro_process/${statusId}/`, {
			params: filtersTransformer(params)
		})
		.then(response => {
      const { avg, data, count} = response.data
      
			return {
        avg, count,
        sinisters: SinisterTransformer.fetchCollection(data || [])
      }
		})
}


// WEBPACK FOOTER //
// ./src/services/sinister/fetchByStatus.js